import React, { lazy, Suspense } from 'react';
import { Router, Route } from 'react-router-dom';
import { StreamApp } from 'react-activity-feed';
import global from '../../stores/GlobalStore';
import _ from 'lodash';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/app';

import Header from '../Header/Header';
import Footer from './Footer';
import UploadModal from '../UploadModal/UploadModal';
import ShowPage from './ShowPage';
import EpisodePage from './EpisodePage';
import ShowsLandingPage from './ShowsLandingPage';
import ClippPage from './ClippPage';
import UserProfile from '../UserProfile/UserProfile';
import SEOHeader from '../Header/SEOHeader';

import Auth from '../../auth/auth';
import history from '../../auth/history';
import { normalizeNavigatorData } from '../../utils/browserUtils';

import './styles/App.scss';
import './styles/AudioPlayer.scss';

const auth = new Auth();

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: auth.isAuthenticated()
        ? global()
            .getUserStore()
            .getUserFromLocalStorage()
        : null,
      show: {},
      episode: {},
      userLocale: (navigator && navigator.language) || 'en-US',
      darkMode: false,
      showUploadModal: false,
      hasError: false,
      playerExpanded: true, // Expand/collapsed player height
    };

    this.firebase = firebase.initializeApp({
      apiKey: 'AIzaSyD4dohsE1LDbOzUI3n85Lbs7GtxZgeL11k',
      authDomain: 'schoonlabs.firebaseapp.com',
      databaseURL: 'https://schoonlabs.firebaseio.com',
      projectId: 'schoonlabs',
      storageBucket: 'schoonlabs.appspot.com',
      messagingSenderId: '107784606954',
      appId: '1:107784606954:web:51a5734897a843c4',
    });

    global()
      .getApi()
      .userApi.getUsersIpAddress()
      .then(response => {
        return response.json();
      })
      .then(ipAddress => {
        if (ipAddress) {
          global()
            .getApi()
            .userApi.getUsersLocation(ipAddress.ip)
            .then(response => {
              return response && response.json();
            })
            .then(userData => {
              global()
                .getUserStore()
                .setUserSessionData(userData);
            });
        }
      })
      .catch(e => console.log(e));

    const browserData = normalizeNavigatorData(window.navigator);
    if (browserData && browserData.mobile) {
      const fbChat = document.getElementById('fb-root');
      if (fbChat) {
        fbChat.style.visibility = 'hidden';
      }
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (error) {
      console.error(error);
      this.setState({ hasError: true });
    }
  }

  requestNotificationAccess = () => {
    /*
        const messaging = this.firebase.messaging();
        messaging.usePublicVapidKey('BC2tfZQCpll7jYIlK--9jsM0SQXfi35ItQ7p7pPIHD5GgNVddjfQczNrzjYK29To2jSG7Bea_CeyVrcaQoqZnrg');

        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                console.log('Notification permission granted.');
                console.log(messaging.getToken());
            } else {
                console.log('Unable to get permission to notify.');
            }
        });
        */
  };

  logoutUser = () => {
    auth.logout();
    window.location.href = '/';
  };

  setLoggedInUser = user => {
    setTimeout(() => {
      this.setState({ user });
    }, 1000);
  };

  setDarkMode = () => {
    this.setState({ darkMode: !this.state.darkMode });
  };

  // Setting episode causes the embedded player to appear in the footer
  setActiveEpisode = (episode, e) => {
    e && e.stopPropagation();

    if (episode && episode.audioData && episode.audioData.length) {
      episode.isLoaded = true;
    }
    this.setState({ episode });
  };

  setActiveShow = (show, e) => {
    e && e.stopPropagation();

    this.setState({ show });
  };

  setEpisodeState = (isPlaying, e) => {
    e && e.stopPropagation();

    const { episode } = this.state;
    if (episode) {
      episode.isPlaying = isPlaying;
    }
    this.setState({ episode });
  };

  // Pop-up Twitter share
  shareEpisode = (e, episode = this.state.episode) => {
    e && e.stopPropagation();

    let url = `https://clipps.schoon.now.sh/player?id=${episode.id}`;
    let text = `${episode.title}`;

    window.open(
      `http://twitter.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      '',
      'left=400,top=200,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
    );
  };

  toggleUploadModal = () => {
    this.setState({ showUploadModal: !this.state.showUploadModal });
  };

  renderEmbeddedPlayer = props => {
    console.log('here');
    const EmbedPlayer = lazy(() => import('../ClippEmbedPlayer/EmbedPlayer'));
    return (
      <Suspense fallback={<div />}>
        <EmbedPlayer
          {...props}
          shareEpisode={this.shareEpisode}
          setEpisodeState={this.setEpisodeState}
          closeEpisode={this.setActiveEpisode.bind(this, {})}
          user={this.state.user}
        />
      </Suspense>
    );
  };

  renderPrivacyPolicy = props => {
    const PrivacyPolicy = lazy(() => import('../Privacy/PrivacyContainer'));
    return (
      <Suspense fallback={<div />}>
        <PrivacyPolicy {...props} userLocale={this.state.userLocale} user={this.state.user} />
      </Suspense>
    );
  };

  renderTermsPolicy = props => {
    const TermsContainer = lazy(() => import('../Privacy/TermsContainer'));
    return (
      <Suspense fallback={<div />}>
        <TermsContainer {...props} userLocale={this.state.userLocale} user={this.state.user} />
      </Suspense>
    );
  };

  renderSubmit = props => {
    const Submit = lazy(() => import('../Pages/Submit'));
    return (
      <Suspense fallback={<div />}>
        <Submit {...props} userLocale={this.state.userLocale} user={this.state.user} />
      </Suspense>
    );
  };

  renderCommunity = props => {
    const Community = lazy(() => import('../Pages/Community'));
    return (
      <Suspense fallback={<div />}>
        <Community {...props} userLocale={this.state.userLocale} user={this.state.user} />
      </Suspense>
    );
  };

  renderShowLinksLanding = props => {
    const ShowLinks = lazy(() => import('../Pages/ShowLinks'));
    return (
      <Suspense fallback={<div />}>
        <ShowLinks {...props} userLocale={this.state.userLocale} user={this.state.user} />
      </Suspense>
    );
  };

  renderFeed = props => {
    if (this.state.show && this.state.show.title) {
      this.setActiveShow({});
    }
    return this.renderShowsLanding(props);
  };

  renderUserProfile = props => {
    return <UserProfile user={this.state.user} darkMode={this.state.darkMode} {...props} />;
  };

  renderClipp = props => {
    return <ClippPage user={this.state.user} darkMode={this.state.darkMode} {...props} />;
  };

  renderShowLinks = props => {
    const ShowLinkPage = lazy(() => import('../Pages/ShowLinkPage'));
    return (
      <Suspense fallback={<div />}>
        <ShowLinkPage
          user={this.state.user}
          darkMode={this.state.darkMode}
          setActiveShow={this.setActiveShow}
          activeShow={this.state.show}
          {...props}
        />
      </Suspense>
    );
  };

  renderShowsLanding = props => {
    return <ShowsLandingPage user={this.state.user} darkMode={this.state.darkMode} {...props} />;
  };

  renderShow = props => {
    return (
      <ShowPage
        user={this.state.user}
        darkMode={this.state.darkMode}
        activeEpisode={this.state.episode}
        setActiveEpisode={this.setActiveEpisode}
        setActiveShow={this.setActiveShow}
        shareEpisode={this.shareEpisode}
        {...props}
      />
    );
  };

  renderEpisode = props => {
    return (
      <EpisodePage
        user={this.state.user}
        darkMode={this.state.darkMode}
        episode={this.state.episode}
        show={this.state.show}
        setActiveShow={this.setActiveShow}
        setActiveEpisode={this.setActiveEpisode}
        {...props}
      />
    );
  };

  renderFeedExtractTool = props => {
    const FeedExtract = lazy(() => import('../Tools/FeedExtract'));
    return (
      <Suspense fallback={<div />}>
        <FeedExtract {...props} />
      </Suspense>
    );
  };

  renderTopPodcastsTool = props => {
    const TopPodcasts = lazy(() => import('../Tools/TopPodcasts'));
    return (
      <Suspense fallback={<div />}>
        <TopPodcasts {...props} />
      </Suspense>
    );
  };

  renderPeaksTool = props => {
    const Peaks = lazy(() => import('../Tools/Peaks'));
    return (
      <Suspense fallback={<div />}>
        <Peaks {...props} />
      </Suspense>
    );
  };

  togglePlayerHeight = () => {
    this.setState({ playerExpanded: !this.state.playerExpanded });
  };

  wrapInStream = childProps => {
    if (this.state.user) {
      return (
        <StreamApp apiKey='cre9kwprgsgz' appId='76051' token={this.state.user && this.state.user.streamToken}>
          {childProps}
        </StreamApp>
      );
    }
  };

  renderChildProps = () => {
    let isMobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
    }

    return (
      <React.Fragment>
        <Header
          user={this.state.user}
          firebase={this.firebase}
          logout={this.logoutUser}
          setLoggedInUser={this.setLoggedInUser}
          setDarkMode={this.setDarkMode}
          toggleUploadModal={this.toggleUploadModal}
          darkMode={this.state.darkMode}
        />
        <div
          className={`app ${_.size(this.state.episode) && this.state.playerExpanded ? 'player-expanded' : ''} ${
            isMobile ? 'mobile-player' : ''
          }`}
        >
          {this.state.showUploadModal && (
            <UploadModal user={this.state.user} darkMode={this.state.darkMode} closeModal={this.toggleUploadModal} />
          )}
          <Router history={history}>
            <React.Fragment>
              <Route
                path='/u/:userId'
                render={props => {
                  return this.renderUserProfile(props);
                }}
              />
              <Route
                exact
                path='/l/:showId'
                render={props => {
                  return this.renderShowLinks(props);
                }}
              />
              <Route
                exact
                path='/_/:clippId'
                render={props => {
                  return this.renderClipp(props);
                }}
              />
              <Route
                exact
                path='/:showId'
                render={props => {
                  if (
                    props.match &&
                    props.match.params &&
                    props.match.params.episodeId !== '/e' &&
                    props.location &&
                    props.location.pathname !== '/privacy' &&
                    props.location &&
                    props.location.pathname !== '/terms' &&
                    props.location &&
                    props.location.pathname !== '/community' &&
                    props.location &&
                    props.location.pathname !== '/casterkit' &&
                    props.location &&
                    props.location.pathname !== '/submit' &&
                    props.location &&
                    props.location.pathname !== '/links' &&
                    props.location &&
                    props.location.pathname !== '/l'
                  ) {
                    return this.renderShow(props);
                  } else {
                    return null;
                  }
                }}
              />
              <Route
                exact
                path='/e/:episodeId'
                render={props => {
                  if (
                    props.match &&
                    props.match.params &&
                    props.match.params.episodeId !== 'shows' &&
                    props.location &&
                    props.location.pathname !== '/privacy' &&
                    props.location &&
                    props.location.pathname !== '/terms' &&
                    props.location &&
                    props.location.pathname !== '/community' &&
                    props.location &&
                    props.location.pathname !== '/casterkit' &&
                    props.location &&
                    props.location.pathname !== '/submit' &&
                    props.location &&
                    props.location.pathname !== '/links' &&
                    props.location &&
                    props.location.pathname !== '/s'
                  ) {
                    return this.renderEpisode(props);
                  } else {
                    return null;
                  }
                }}
              />
              <Route
                exact
                path='/casterkit'
                render={props => {
                  return this.renderFeed(props);
                }}
              />
              <Route
                exact
                path='/community'
                render={props => {
                  return this.renderCommunity(props);
                }}
              />
              <Route
                exact
                path='/links'
                render={props => {
                  return this.renderShowLinksLanding(props);
                }}
              />
              <Route
                exact
                path='/l'
                render={props => {
                  return this.renderShowLinksLanding(props);
                }}
              />
              <Route
                path='/shows'
                render={props => {
                  return this.renderFeed(props);
                }}
              />
              <Route
                exact
                path='/submit'
                render={props => {
                  return this.renderSubmit(props);
                }}
              />
              <Route
                exact
                path='/add'
                render={props => {
                  return this.renderSubmit(props);
                }}
              />
              <Route
                exact
                path='/privacy'
                render={props => {
                  return this.renderPrivacyPolicy(props);
                }}
              />
              <Route
                exact
                path='/terms'
                render={props => {
                  return this.renderTermsPolicy(props);
                }}
              />
              <Route
                exact
                path='/tools/peaks'
                render={props => {
                  return this.renderPeaksTool(props);
                }}
              />
              <Route
                exact
                path='/tools/extract'
                render={props => {
                  return this.renderFeedExtractTool(props);
                }}
              />
              <Route
                exact
                path='/tools/topPodcasts'
                render={props => {
                  return this.renderTopPodcastsTool(props);
                }}
              />
              <Route
                exact
                path='/'
                render={props => {
                  return this.renderFeed(props); //this.renderShowsLanding(props)
                }}
              />
            </React.Fragment>
          </Router>
        </div>
        <Footer
          user={this.state.user}
          episode={this.state.episode}
          show={this.state.show}
          shareEpisode={this.shareEpisode}
          setActiveEpisode={this.setActiveEpisode}
          setEpisodeState={this.setEpisodeState}
          playerExpanded={this.state.playerExpanded}
          togglePlayer={this.togglePlayerHeight}
        />
      </React.Fragment>
    );
  };

  render() {
    if (this.state.hasError) {
      return this.renderChildProps();
    }

    return (
      <>
        <SEOHeader show={this.state.show} episode={this.state.episode} />
        <Router history={history}>
          <React.Fragment>
            <Route
              exact
              path='/e/player'
              render={props => {
                return this.renderEmbeddedPlayer(props);
              }}
            />
            <Route
              path='/'
              render={props => {
                if (props.location && props.location.pathname.indexOf('/e/player') > -1) {
                  return null;
                }

                return (
                  <div style={{ backgroundImage: `url('/bg.jpg')`, height: '100%' }}>
                    {this.state.user ? this.wrapInStream(this.renderChildProps()) : this.renderChildProps()}
                  </div>
                );
              }}
            />
          </React.Fragment>
        </Router>
      </>
    );
  }
}

export default App;
